"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioForDevelopment = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const use_media_in_timeline_1 = require("../use-media-in-timeline");
const use_media_playback_1 = require("../use-media-playback");
const use_media_tag_volume_1 = require("../use-media-tag-volume");
const use_sync_volume_with_media_tag_1 = require("../use-sync-volume-with-media-tag");
const volume_position_state_1 = require("../volume-position-state");
const use_audio_frame_1 = require("./use-audio-frame");
const AudioForDevelopmentForwardRefFunction = (props, ref) => {
    const audioRef = react_1.useRef(null);
    const [mediaVolume] = volume_position_state_1.useMediaVolumeState();
    const [mediaMuted] = volume_position_state_1.useMediaMutedState();
    const volumePropFrame = use_audio_frame_1.useFrameForVolumeProp();
    const { volume, muted, playbackRate, ...nativeProps } = props;
    const actualVolume = use_media_tag_volume_1.useMediaTagVolume(audioRef);
    use_sync_volume_with_media_tag_1.useSyncVolumeWithMediaTag({
        volumePropFrame,
        actualVolume,
        volume,
        mediaVolume,
        mediaRef: audioRef,
    });
    use_media_in_timeline_1.useMediaInTimeline({
        volume,
        mediaVolume,
        mediaRef: audioRef,
        src: nativeProps.src,
        mediaType: 'audio',
    });
    use_media_playback_1.useMediaPlayback({
        mediaRef: audioRef,
        src: nativeProps.src,
        mediaType: 'audio',
        playbackRate: playbackRate !== null && playbackRate !== void 0 ? playbackRate : 1,
    });
    react_1.useImperativeHandle(ref, () => {
        return audioRef.current;
    });
    return jsx_runtime_1.jsx("audio", Object.assign({ ref: audioRef, muted: muted || mediaMuted }, nativeProps), void 0);
};
exports.AudioForDevelopment = react_1.forwardRef(AudioForDevelopmentForwardRefFunction);
//# sourceMappingURL=AudioForDevelopment.js.map